module.exports = __webpack_public_path__ + "img/banner-ERS.8d868b03.png";